/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selectbusinessdescription2Inputs */

const en_selectbusinessdescription2 = /** @type {(inputs: Selectbusinessdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a business to view and manage their dashboard`)
};

const de_selectbusinessdescription2 = /** @type {(inputs: Selectbusinessdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Unternehmen aus, um das Dashboard anzusehen und zu verwalten`)
};

/**
* | output |
* | --- |
* | "Select a business to view and manage their dashboard" |
*
* @param {Selectbusinessdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const selectbusinessdescription2 = /** @type {((inputs?: Selectbusinessdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectbusinessdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selectbusinessdescription2(inputs)
	return de_selectbusinessdescription2(inputs)
});
export { selectbusinessdescription2 as "selectBusinessDescription" }